import script from "./VerticalModal.vue?vue&type=script&setup=true&lang=js"
export * from "./VerticalModal.vue?vue&type=script&setup=true&lang=js"

import "./VerticalModal.vue?vue&type=style&index=0&id=2b61cbce&lang=css"

const __exports__ = script;

export default __exports__